module.exports = __webpack_public_path__ + "img/flag.f0163793.png";